<script setup lang="ts">
/**
 * RinganIkon — pengganti <UIcon> untuk halaman "ringan".
 *
 * <UIcon> menarik komponen Nuxt UI + runtime Iconify ke dalam bundel halaman.
 * Di halaman kompres itu tidak sepadan: yang dibutuhkan cuma belasan ikon
 * statis yang tidak pernah berubah saat runtime.
 *
 * Di sini path SVG-nya disalin dari paket @iconify-json/lucide YANG SAMA
 * (lihat scripts/buat-ikon.mjs), lalu ditanam langsung ke markup. Bentuk
 * ikonnya identik dengan layout utama, bukan sekadar mirip.
 *
 * Perbedaan teknis yang perlu diketahui: <UIcon> merender <span> ber-mask CSS,
 * komponen ini merender <svg> sungguhan. Keduanya mewarisi warna lewat
 * `currentColor` dan diukur dengan utility `size-*` yang sama, sehingga hasil
 * di layar tidak berbeda. `vertical-align: middle` disamakan dengan perilaku
 * inline-block milik <UIcon> supaya ikon di dalam teks tidak turun sebaris.
 */
import { IKON } from './ikon'

const props = defineProps<{
  /** Nama ikon Lucide, boleh dengan atau tanpa prefiks (mis. 'gift' / 'i-lucide-gift'). */
  nama: string
}>()

const kunci = computed(() => props.nama.replace(/^i-lucide[-:]/, ''))
const badan = computed(() => IKON[kunci.value] ?? '')

if (import.meta.dev && !badan.value) {
  // Sengaja peringatan, bukan lemparan: ikon yang hilang tidak boleh
  // menjatuhkan halaman alat yang sedang dipakai orang.
  console.warn(
    `[RinganIkon] ikon "${props.nama}" belum disalin. Tambahkan ke daftar DIPAKAI di scripts/buat-ikon.mjs lalu jalankan ulang.`
  )
}
</script>

<template>
  <svg
    v-if="badan"
    class="ringan-ikon"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    aria-hidden="true"
    focusable="false"
    v-html="badan"
  />
</template>

<style scoped>
.ringan-ikon {
  display: inline-block;
  vertical-align: middle;
  /* `size-*` dari pemanggil menetapkan width/height dalam rem; width/height="1em"
     hanya bertindak sebagai nilai dasar bila pemanggil tidak menetapkan apa pun. */
  flex-shrink: 0;
}
</style>
